import React from 'react';

export const RoundSymbol = ({size, color, borderSize, className} : {size:number, color: "white" | "black", borderSize?: number, className?: string}) => {
    return (
        <div className={`border-${color} rounded-full ${className || ''}`} 
        style={{ width: size, height: size, borderWidth: borderSize || 4 }} />
    )
}